<template>
  <div id="app-root">
    <nav v-if="showNavBar" class="top-nav">
      <span class="top-nav-title">{{ pageTitle }}</span>
      <router-link to="/" class="top-nav-home">
        <i class="fas fa-home"></i>
        <span>返回首页</span>
      </router-link>
    </nav>
    <main>
      <router-view />
    </main>
    <footer v-if="!isScreen" class="site-footer">
      <span>网站备案号：蜀ICP备2025136249号</span>
      <span class="footer-sep">|</span>
      <span>联系方式：蔡旭 17746755494</span>
    </footer>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

export default {
  name: 'App',
  setup() {
    const route = useRoute()
    // 大屏路由（meta.screen）全屏展示，不显示导航与页脚
    const isScreen = computed(() => !!route.meta.screen)
    const showNavBar = computed(() => route.path !== '/' && !route.meta.screen)
    const pageTitle = computed(() => route.meta.title || '')
    return { isScreen, showNavBar, pageTitle }
  }
}
</script>

<style>
.top-nav {
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 var(--space-lg);
  height: var(--nav-height);
  background: var(--nav-bg);
  backdrop-filter: var(--blur-glass);
  -webkit-backdrop-filter: var(--blur-glass);
  border-bottom: 1px solid var(--border-light);
}

.top-nav-title {
  font-size: var(--font-lg);
  font-weight: 600;
  color: var(--text-primary);
}

.top-nav-home {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: var(--font-sm);
  color: var(--primary);
  transition: opacity var(--transition-fast);
}

.top-nav-home:hover {
  opacity: 0.8;
  color: var(--primary);
}

.site-footer {
  margin-top: var(--space-2xl);
  border-top: 1px solid var(--border-color);
  padding: var(--space-lg) 0;
  text-align: center;
  font-size: var(--font-sm);
  color: var(--text-muted);
}

.footer-sep {
  margin: 0 var(--space-sm);
}
</style>
